/* @flow */
import { SharingGroup } from './types';
import { Map } from 'immutable';

export const sharingGroupToFormOptions = (sharingGroup: SharingGroup) =>
  Map({
    value: sharingGroup.get('guid'),
    id: sharingGroup.get('guid'),
    label: sharingGroup.get('name'),
  });



// WEBPACK FOOTER //
// ./src/app/modules/groups/utils.js